import api from '@/utils/api';

const { baseApi } = window.GlobalConfig;

// 客户组件数据
export const queryComponentCustomerData = data => {
    return api.post(`${baseApi}/component/getComponentUserListByCustomerDataAuthority`);
};

export const queryComponentCustomer = data => {
    return api.post(`${baseApi}/component/getComponentCustomerByDataAuthority`, data);
};

export const SearchComponentCustomer = data => {
    return api.post(`${baseApi}/component/getComponentCustomerByNoCustomerDataAuthority`, data);
};
// 区域组件无权限数据
export const queryComponetArea = data => {
    return api.post(`${baseApi}/component/getComponentAreaRegionTreeByCustomerNoDataAuthority`, data);
};

export const QueryComponentAreaList = data => {
    return api.post(`${baseApi}/component/getComponentAreaRegionTreeByCustomerDataAuthority`, data);
};

// 区域组件权限数据
export const queryComponetAuthArea = data => {
    return api.post(`${baseApi}/component/getComponentAreaRegionTreeByDataAuthority`, data);
};

// 新的组件权限数据
export const QueryComponentAreaAuth = data => {
    return api.post(`${baseApi}/component/getComponentAreaRegionTreeByDataAuthority`, data);
};

// 客户查询用户
export const queryComponentUser = data => {
    return api.post(`${baseApi}/component/getComponentUserListByDataAuthority`, data);
};

// 查询已提交计划
export const QuerySubmitPlanList = data => {
    return api.post(`${baseApi}/component/getComponentVisitPlan`, data);
};

export const queryUserListAll = data => {
    return api.post(`${baseApi}/component/getComponentUserList`, data);
};

//
export const queryRegionTreeList = () => {
    return api.get(`${baseApi}/component/getComponentAreaRegionTree`);
};

// 竞争对手

export const queryCompetiorAll = data => {
    return api.post(`${baseApi}/component/getComponentCompetitorList`, data);
};

// 预测项目
export const queryForecastClauseList = data => {
    return api.post(`${baseApi}/component/getComponentMedicalItemList4Customer`, data);
};

export const QueryComponentClausePage = data => {
    return api.post(`${baseApi}/component/getComponentMedicalItemListPage`, data);
};

export const QueryComponentClauseNyCustomerPage = data => {
    return api.post(`${baseApi}/component/getComponentMedicalItemList4CustomerNoAssociation`, data);
};

// 未合作状态
export const QueryStatusComponents = () => {
    return api.get(`${baseApi}/component/getComponentCustomerStatusExceptDevelopList`);
};

// 部门组件

export const QueryDeptComponent = () => {
    return api.get(`${baseApi}/component/getComponentDeptTree`);
};

export const QueryAuthDeptComponent = () => {
    return api.get(`/component/getComponentDept4CurrentUserTree`);
};

// 岗位组件

export const QueryPostComponent = () => {
    return api.get(`${baseApi}/component/getComponentPostList`);
};

export const QueryRoomAllList = () => {
    return api.get(`${baseApi}/component/getComponentDepartmentList`);
};

export const QueryRoleList = () => {
    return api.get(`${baseApi}/component/getComponentRoleList`);
};

export const QueryDoctorAll = data => {
    return api.post(`${baseApi}/component/getComponentEmployeeList`, data);
};

export const QueryEmployeeAll = data => {
    return api.post(`${baseApi}/component/getComponentEmployeeList4CustomerList`, data);
};

// 配置项

export const QueryConfigItem = data => {
    return api.post(`${baseApi}`, data);
};

export const QueryRegionByAreaId = ({ areaId }) => {
    return api.get(`${baseApi}/component/getComponentAreaRegionTreeByAreaId/${areaId}`);
};

export const QueryComponentsClassify = () => {
    return api.get(`${baseApi}/component/getComponentDictClassificationList`);
};

export const QueryComponentsTypeByClassify = classification => {
    return api.get(`${baseApi}/component/getComponentDictTypeList?classificationId=${classification}`);
};

export const QueryComponentsType = (classification = '') => {
    return api.get(`${baseApi}/component/getComponentDictTypeList?classificationId=${classification}`);
};

export const QuerySubUser = data => {
    return api.post(`${baseApi}/component/getComponentUserSubordinates`, data);
};

//
export const QueryPassStatus = () => {
    return api.get(`/component/getComponentCustomerStatusCodeHasCooperation`);
};

export const QueryNotStatus = () => {
    return api.get(`/component/getComponentCustomerStatusCodeNotCooperation`);
};

export const QueryUserSubList = data => {
    return api.post(`/component/getComponentUserSubordinatesWithSelf`, data);
};

export const QueryPrecentCode = code => {
    return api.get(`/config/getConfigByCode/${code}`);
};

export const UpdatePrecentCode = data => {
    return api.post(`/config/updateConfig`, data);
};

//
export const QueryActionTree = () => {
    return api.get(``);
};

// 查询所有的未解决风险
export const QueryRiskList = () => {
    return api.get(`/component/getComponentRecordIssueNotSolvedList`);
};

// 查询所有的行动计划
export const QueryActionComponent = () => {
    return api.get(``);
};

//查询所有的岗位

export const QueryPostAll = () => {
    return api.get(`/component/getComponentPostList`);
};

// 查询用户的kpi
export const QueryKpiByUser = ({ userId }) => {
    return api.get(`/component/getComponentActionIndicatorListByUserId/${userId}`);
};

export const QueryIndicatorByUserIds = data => {
    return api.post(`/component/getComponentActionIndicatorListByUserIdListIntersection`, data);
};

export const QueryKeypointByUser = () => {
    return api.get(`/component/getComponentKeypointList4CurrentUser`);
};

//

export const QueryActionPlan = data => {
    return api.post(`/actionPlan/getActionPlanListByKeypointId`, data);
};

export const QueryVisitList = data => {
    return api.post(`/visit/getVisitListByKeypointId`, data);
};

export const QueryVisitByAction = data => {
    return api.post(`/visit/getVisitListByActionPlanId`, data);
};

export const QueryVisitPlanByAction = data => {
    return api.post(`/visitPlan/getVisitPlanByActionPlanId`, data);
};

export const QueryindicatorAll = () => {
    return api.get(`/component/getComponentActionIndicatorList`);
};

export const QueryDifficultReason = () => {
    return api.get(`/component/getComponentReturnDifficultReasonTypeCodeList`);
};

export const QueryDifficultAreaTree = () => {
    return api.get(`/component/getComponentAreaTreeByCurrentUserManageTypeCode4Return`);
};

export const QueryDashArea = code => {
    return api.get(`/component/getComponentAreaTreeByCurrentUserManageTypeCode/${code}`);
};

export const QueryOpportunityAll = () => {
    return api.get(``);
};
